import { render, staticRenderFns } from "./TeacherPayment.vue?vue&type=template&id=0bf4571a"
import script from "../../services/teacher/teacher-payment.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/teacher-payment.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports